"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
class Navbar {
    static init() {
        this.menuToggle();
        const breakpoint = window.matchMedia('(max-width:768px)');
        document.querySelectorAll('.mobile-dropdown-toggle').forEach(function (toggler) {
            if (toggler.parentNode) {
                const dropdownWrapper = toggler.parentNode.querySelector('.dropdown-menu');
                const parentToggle = toggler.parentNode;
                toggler.addEventListener('click', function () {
                    // @ts-ignore
                    const current = this;
                    function breakpointChecker() {
                        if (breakpoint.matches) {
                            return;
                        }
                        else if (!breakpoint.matches) {
                            return enableDropdownFunction();
                        }
                    }
                    const enableDropdownFunction = function () {
                        document.querySelectorAll('.mobile-dropdown-toggle').forEach(function (toggler) {
                            var _a;
                            if (current !== toggler) {
                                const dropdownWrapper = (_a = toggler.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector('.dropdown-menu');
                                const parentToggle = toggler.parentNode;
                                toggler.classList.remove('open');
                                dropdownWrapper === null || dropdownWrapper === void 0 ? void 0 : dropdownWrapper.classList.remove('open');
                                parentToggle === null || parentToggle === void 0 ? void 0 : parentToggle.classList.remove('dropdown-open');
                            }
                        });
                    };
                    toggler.classList.toggle('open');
                    dropdownWrapper === null || dropdownWrapper === void 0 ? void 0 : dropdownWrapper.classList.toggle('open');
                    parentToggle === null || parentToggle === void 0 ? void 0 : parentToggle.classList.toggle('dropdown-open');
                    breakpoint.addEventListener('change', breakpointChecker);
                    breakpointChecker();
                });
            }
        });
    }
    static menuToggle() {
        const navbar = document.querySelector('nav.js-mainNavbar');
        const navToggle = document.querySelector('.navbar-toggle');
        if (!navbar || !navToggle) {
            return;
        }
        navbar.addEventListener('click', () => {
            navbar.classList.toggle('mobile-menu-open');
        });
    }
}
exports.Navbar = Navbar;
